












































import Vue from "vue"
import Component from "vue-class-component"
import screenfull from "screenfull"
import { getModule } from "vuex-module-decorators"
import AppModule from "@/store/modules/app.module"
import DevLinks from "../../components/devLinks/DevLinks.vue"
import UserProfile from "../../components/userProfile/UserProfile.vue"
import Footer from "../../components/footer/Footer.vue"

const sf = screenfull

@Component({
  components: {
    "app-dev-links": DevLinks,
    "app-user-profile": UserProfile,
    "app-footer": Footer,
  },
})
export default class AccessDenied extends Vue {
  public appModule = getModule(AppModule, this.$store)

  private stagingClass: string = "blue darken-3"
  private developmentClass: string = "red darken-3"

  private isFullscreen = false

  primaryDrawer: any = {
    model: null,
    type: "temporary",
    clipped: false,
    floating: false,
    mini: false,
  }

  constructor() {
    super()
  }

  mounted() {
    if (sf && sf.enabled) {
      sf.on("change", this.change)
    }
  }

  beforeDestory() {
    if (sf && sf.enabled) {
      sf.off("change", this.change)
    }
  }

  private change() {
    if (sf && sf.enabled) {
      this.isFullscreen = sf.isFullscreen
    }
  }

  toggleFullscreen() {
    if (sf) {
      sf.toggle()
    }
  }
}
